module.exports = {"profileDetails":{"summaryData":{}}}


//////////////////
// WEBPACK FOOTER
// ./src/initialState.json
// module id = 375
// module chunks = 0